import { observable } from 'mobx';
import type { OrderItemStepResponseArgs } from './order_item_step';
import OrderItemStep, { convertOrderItemStepResponseToArgs } from './order_item_step';

export type OrderItemStepSequenceResponseArgs = {
  id: number;
  trace_id: number;
  current_step_id?: number;
  master_step_sequence_id: number;
  master_step_name: string;
  master_step_code: string;
  current_step?: OrderItemStepResponseArgs;
};

export type OrderItemStepSequenceArgs = {
  id?: number;
  traceId: number;
  currentStepId?: number;
  masterStepSequenceId: number;
  masterStepName: string;
  masterStepCode: string;
  currentStep?: OrderItemStep;
};

export const convertOrderItemStepSequenceResponseToArgs = (response: OrderItemStepSequenceResponseArgs) => {
  const args: OrderItemStepSequenceArgs = {
    id: response.id,
    traceId: response.trace_id,
    currentStepId: response.current_step_id,
    masterStepSequenceId: response.master_step_sequence_id,
    masterStepName: response.master_step_name,
    masterStepCode: response.master_step_code,
    currentStep: response.current_step
      ? new OrderItemStep(convertOrderItemStepResponseToArgs(response.current_step))
      : undefined
  };
  return args;
};

export default class OrderItemStepSequence {
  @observable id?: number;
  @observable traceId: number;
  @observable currentStepId?: number;
  @observable masterStepSequenceId: number;
  @observable masterStepName: string;
  @observable masterStepCode: string;
  @observable currentStep?: OrderItemStep;

  constructor(args: OrderItemStepSequenceArgs) {
    this.id = args.id;
    this.traceId = args.traceId;
    this.currentStepId = args.currentStepId;
    this.masterStepSequenceId = args.masterStepSequenceId;
    this.masterStepName = args.masterStepName;
    this.masterStepCode = args.masterStepCode;
    this.currentStep = args.currentStep;
  }
}
